import { render, staticRenderFns } from "./ColorRichText.vue?vue&type=template&id=53966866&"
import script from "./ColorRichText.vue?vue&type=script&lang=js&"
export * from "./ColorRichText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports